"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Execute callback when a property or an attribute of element changes
 * returns unwatch function that removes watcher
 * const unwatch = watchProperty(input, 'value', () => console.log('Value changed'));
 * input.value = 'newValue' // => Value changed
 * input.setAttribute('value', 'another value') // => Value changed
 * input.removeAttribute('value') // => Value changed
 * unwatch()
 * input.value = '123' // logs nothing
 */
function watchProperty(element, prop, cb) {
    var el = element;
    if (!el.hasOwnProperty('__watchedProperties')) {
        var nativeSetAttr_1 = Object.getOwnPropertyDescriptor(findPropertyOwner(element, 'setAttribute'), 'setAttribute');
        var nativeRemoveAttr_1 = Object.getOwnPropertyDescriptor(findPropertyOwner(element, 'removeAttribute'), 'removeAttribute');
        Object.defineProperty(el, '__watchedProperties', {
            writable: true,
            configurable: true,
            enumerable: false,
            value: {}
        });
        Object.defineProperties(el, {
            setAttribute: {
                writable: true,
                configurable: true,
                enumerable: true,
                value: function (attr, value) {
                    nativeSetAttr_1.value.apply(this, arguments);
                    if (this.__watchedProperties[attr]) {
                        notify(this, attr);
                    }
                }
            },
            removeAttribute: {
                writable: true,
                configurable: true,
                enumerable: true,
                value: function (attr) {
                    nativeRemoveAttr_1.value.apply(this, arguments);
                    if (this.__watchedProperties[attr]) {
                        notify(this, attr);
                    }
                }
            }
        });
    }
    // if the prop not in watchedProperties, nobody watches it yet
    if (!el.__watchedProperties[prop]) {
        var owner = findPropertyOwner(el, prop) || {};
        var nativeDesc_1 = Object.getOwnPropertyDescriptor(owner, prop);
        if (nativeDesc_1) { // if element doesn't have nativeDesc it doesn't react on prop changes. So do we
            Object.defineProperty(el, prop, {
                get: function () {
                    return nativeDesc_1.get.call(this);
                },
                set: function (v) {
                    nativeDesc_1.set.call(this, v);
                    notify(this, prop);
                },
                enumerable: nativeDesc_1.enumerable,
                configurable: true
            });
        }
        el.__watchedProperties[prop] = [];
    }
    el.__watchedProperties[prop].push(cb);
    return function unwatch() {
        var index = el.__watchedProperties[prop].indexOf(cb);
        el.__watchedProperties[prop].splice(index, 1);
    };
}
exports.watchProperty = watchProperty;
function notify(element, prop) {
    element.__watchedProperties[prop].forEach(function (cb) { return cb(); });
}
// @internal
function findPropertyOwner(object, property) {
    if (object === null) {
        return null;
    }
    else if (object.hasOwnProperty(property)) {
        return object;
    }
    else {
        return findPropertyOwner(Object.getPrototypeOf(object), property);
    }
}
exports.findPropertyOwner = findPropertyOwner;
